// Created to only provide Merchant MetaData
// For Product Specific Merchant checks and Feature Toggles, use MerchantProvider
import React, { useContext, useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { UserDetailsContext } from 'contexts/UserDetailsContext';
import { fetchUserDetails, validateToken } from 'services/userDetails';
import _get from 'lodash/get';

import { user } from 'utils/constants';
import { AuthContext } from '../contexts/AuthContext';

// Need to export as components, apart from default for supporting Module Federation
export const UserDetailsProvider = ({ children }) => {
  const { env, userObj } = useContext(AuthContext);
  const [isUserDetailsFetched, setUserDetailsFetched] = useState(false);
  const [userDetails, setUserDetails] = useState({});

  const populateUserDetails = UserDetailsResponse => {
    setUserDetails(UserDetailsResponse);
    setUserDetailsFetched(true);
  };

  const getUserDetails = async () => {
    if (userObj && userObj.cfToken && userObj.cfToken[env]) {
      const { token } = userObj.cfToken[env];

      const validateTokenResponse = await validateToken(token);
      let aliasEmail = _get(validateTokenResponse, 'aliasEmail', '');
      const userType = _get(
        validateTokenResponse,
        'userType',
        user.MERCHANT_OWNER,
      );

      const profilePopupDetails = {
        email:
          userType === user.MERCHANT_ALIAS
            ? aliasEmail
            : _get(validateTokenResponse, 'email'),
      };

      if (!aliasEmail) aliasEmail = 'NA';

      const userDetailsResponse = await fetchUserDetails(
        token,
        userType,
        aliasEmail,
      );

      populateUserDetails({ ...userDetailsResponse, profilePopupDetails });
    }
  };

  useEffect(() => {
    if (!isUserDetailsFetched) {
      getUserDetails();
    }
  }, [isUserDetailsFetched]);

  const value = useMemo(
    () => ({
      userDetails,
    }),
    [userDetails],
  );

  return (
    <UserDetailsContext.Provider value={value}>
      {children}
    </UserDetailsContext.Provider>
  );
};

export default UserDetailsProvider;

UserDetailsProvider.propTypes = {
  children: PropTypes.any,
};
